<template>
  <div
    ref="heroSection"
    class="tw:bg-green-200 tw:pt-[40px] tw:md:pt-[60px] tw:min-h-[485px] tw:md:min-h-[600px] tw:relative"
  >
    <ContainerLayout class="tw:h-full tw:flex tw:flex-col tw:md:flex-row tw:gap-y-10">
      <div
        class="tw:w-full tw:md:w-3/5 tw:lg:w-1/2 tw:flex tw:flex-col tw:gap-[40px] tw:md:gap-y-12 tw:lg:gap-y-[70px] tw:md:mr-16 tw:lg:mr-auto"
      >
        <div class="tw:flex tw:flex-col tw:gap-y-4">
          <h1
            class="tw:text-[32px] tw:lg:text-[44px] tw:leading-[40px] tw:lg:leading-[55px]"
            data-testid="rc-non-connectivity-hero-header-text"
            v-html="$t('rc_product_page_header_new')"
          />
          <h1
            class="tw:text-[32px] tw:lg:text-[44px] tw:leading-[40px] tw:lg:leading-[55px]"
            v-html="$t('rc_product_page_subtext')"
          />
        </div>

        <div>
          <p
            class="tw:mb-6"
            data-testid="rc-eligibility-booking-engine-text"
            v-html="$t('rc_elibility_booking_engine')"
          />
          <AvailablePartnersSelector :partners="sortedAllPartnersData || []" />
        </div>
      </div>

      <div class="tw:w-full tw:md:w-2/5 tw:lg:w-1/2 tw:flex tw:items-end tw:justify-end tw:h-full">
        <img
          :src="heroImage"
          alt="Rate Connect"
          class="tw:mx-auto tw:max-h-[388px] tw:md:max-h-[431px] tw:lg:max-h-[503px] tw:w-auto tw:md:absolute tw:bottom-0"
        />
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import ContainerLayout from '@/layouts/ContainerLayout.vue'
import AvailablePartnersSelector from '@/components/rateConnect/notEligible/AvailablePartnersSelector.vue'

import { useAllPartners } from '@/components/rateConnect/queries'
import { useIsMobile } from '@/composables/useIsMobile'
import { useSessionValues } from '@/composables/useSessionValues'

defineProps({
  isEligible: Boolean,
})
const heroImages = import.meta.glob('/src/assets/img/rate-connect/hero-image/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
})

const { screenWidth } = useIsMobile()
const screenSize = computed(() => {
  if (screenWidth.value > 1024) {
    return 'l'
  } else if (screenWidth.value > 768) {
    return 'm'
  } else if (screenWidth.value >= 500) {
    return 's'
  } else {
    return 'xs'
  }
})

const { language } = useSessionValues()
const currentLocation = computed(() => language.value.split('-')[1].toLowerCase())
const { allPartnersData } = useAllPartners()

const sortedAllPartnersData = computed(() => {
  if (!Array.isArray(allPartnersData.value)) return []

  return allPartnersData.value
    .map(item => ({
      label: item.partnerName,
      value: item.partnerId,
      isPartner: true,
    }))
    .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
})

const heroImage = computed(() => {
  const path = `/src/assets/img/rate-connect/hero-image/hero_image_${screenSize.value}_${currentLocation.value}.png`
  return heroImages[path] || ''
})
</script>
